import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Java = () => {
  return (
    <StartInterviewLayout type="java"/>
  )
}

export default Java;